var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1160_58362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8687 16.6754C29.8687 14.9176 28.5758 13.5035 26.9781 13.5035C24.8141 13.4023 22.607 13.3633 20.3516 13.3633H19.6484C17.3984 13.3633 15.1875 13.4023 13.0234 13.5039C11.4297 13.5039 10.1367 14.9258 10.1367 16.6836C10.0391 18.0738 9.99765 19.4645 9.99999 20.8551C9.99609 22.2457 10.0404 23.6376 10.1328 25.0309C10.1328 26.7887 11.4258 28.2145 13.0195 28.2145C15.293 28.3199 17.625 28.3668 19.9961 28.3629C22.3711 28.3707 24.6966 28.3212 26.9727 28.2145C28.5703 28.2145 29.8633 26.7887 29.8633 25.0309C29.957 23.6363 30 22.2457 29.9961 20.8512C30.0049 19.4605 29.9625 18.0686 29.8687 16.6754ZM18.0859 24.6871V17.0113L23.75 20.8473L18.0859 24.6871Z",
    fill: "#929CB0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.36328,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#E7EBF2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1160_58362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10.8633)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.42d652240168e578831c5e438710b178.svg";
export { ForwardRef as ReactComponent };